import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconImageArrow = () => {
  return (
    <g>
      <path
        d="M15 0a1 1 0 0 1 1 1v8.204l-1.5-.3V1.5h-13v9.438L4.97 7.47a.75.75 0 0 1 .976-.073l.084.073 1.828 1.827.531 2.653L5.5 9.061l-4 3.999v1.44h7.199l.3 1.5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zm-4.998 9.504 4.52.883a.423.423 0 0 1 .217.714l-.926.926 2.059 2.058a.423.423 0 0 1 0 .598l-1.187 1.187a.423.423 0 0 1-.598 0l-2.059-2.059-.925.927a.423.423 0 0 1-.714-.218L9.506 10a.423.423 0 0 1 .496-.496zM9.5 3.5a2.5 2.5 0 0 1 1.263 4.658L8.122 7.63a.423.423 0 0 0-.396.13A2.5 2.5 0 0 1 9.5 3.5zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        
      />
    </g>
  );
};


export default withIcon(IconImageArrow);
